import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Box, Grid, Typography } from "@mui/material";

export function TimeField({ disabled, Controller, control, onlyDate, watch, selectedActivity, editView, setValue }) {
  // const resizeable = selectedActivity?.dragToResize === true;
  // const moveable = selectedActivity?.dragToMove === true;
  // const timeDifferenceInMSRef = React.useRef(null);
  // if (editView && timeDifferenceInMSRef.current === null) {
  //   timeDifferenceInMSRef.current = watch("endTime").diff(watch("startTime"), "millisecond");
  // }

  const views = onlyDate ? ["day", "month", "year"] : undefined;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid
        container
        sx={(theme) => ({
          border: `1px solid ${theme.palette.action.disabled}`,
          borderRadius: "4px",
        })}
      >
        <Grid size={6} sx={{ display: "flex", justifyContent: "center" }}>
          <Box>
            <Typography sx={(theme) => ({ borderBottom: `1px solid ${theme.palette.action.disabled}`, width: "min-content" })}>
              Start
            </Typography>
            <Controller
              name="startTime"
              control={control}
              render={({ field }) => {
                return (
                  <DateTimePicker
                    {...field}
                    // onChange={(val) => {
                    //   if (!val) return;
                    //   field.onChange(val);
                    //   if (moveable && editView) {
                    //     // in edit view
                    //     const newEndTime = val.add(timeDifferenceInMSRef.current, "millisecond");
                    //     setValue("endTime", newEndTime, { shouldDirty: true });
                    //   }
                    // }}
                    maxDateTime={watch ? watch("endTime") : undefined}
                    disabled={disabled}
                    views={views}
                    slotProps={{
                      textField: {
                        variant: "standard", // Use no outline by default
                        InputProps: {
                          disableUnderline: true, // Remove the underline if any
                        },
                        sx: {
                          // For safety, ensure no outline
                          "& .MuiInputBase-root": {
                            background: "transparent",
                          },
                        },
                        required: true,
                      },
                    }}
                  />
                );
              }}
            />
          </Box>
        </Grid>

        <Grid size={6} sx={{ display: "flex", justifyContent: "center" }}>
          <Box>
            <Typography sx={(theme) => ({ borderBottom: `1px solid ${theme.palette.action.disabled}`, width: "min-content" })}>
              End
            </Typography>

            <Controller
              name="endTime"
              control={control}
              render={({ field }) => {
                return (
                  <DateTimePicker
                    {...field}
                    // onChange={(val) => {
                    //   if (!val) return;
                    //   field.onChange(val);
                    //   if (moveable && editView) {
                    //     // in edit view
                    //     const newStartTime = val.subtract(timeDifferenceInMSRef.current, "millisecond");
                    //     setValue("startTime", newStartTime, { shouldDirty: true });
                    //   }
                    // }}
                    minDateTime={watch ? watch("startTime") : undefined}
                    disabled={disabled}
                    views={views}
                    slotProps={{
                      textField: {
                        variant: "standard", // Use no outline by default
                        InputProps: {
                          disableUnderline: true, // Remove the underline if any
                        },
                        sx: {
                          // For safety, ensure no outline
                          "& .MuiInputBase-root": {
                            background: "transparent",
                          },
                        },
                        required: true,
                      },
                    }}
                  />
                );
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
}
